import ChatWindow from '@/pages/live-chat/components/ChatWindow';

export default function LiveChatStandalone() {
  return (
    <div className="h-screen w-full flex flex-col bg-background-50 overflow-hidden">
      <ChatWindow bare />
    </div>
  );
}